import ApiService from './ApiService'

import AuthService from './AuthService'

import HARDCODE from '../business-const/HardCode/HardCode'

import {
    ano,
    mes,
    dia,
} from '../business-components/Date/Date'

import {
    usuarioInfo,
} from './UsuarioService'



class ApoliceComissaoService extends ApiService {

    constructor() {
        super(HARDCODE.apiApoliceComissao)
    }

    async atualizarSalvarDeletarApoliceComissaoList(variaveisGlobais, idUsuario, idArquivo, seguradora, jsonApoliceComissaoList) {

        const apoliceComissaoListDTO = {
            idUsuario: idUsuario,
            idArquivo: idArquivo,
            seguradora: seguradora,
	        jsonApoliceComissaoList: jsonApoliceComissaoList,
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.post(variaveisGlobais, HARDCODE.apiApoliceComissaoAtualizarSalvarDeletarApoliceComissaoList,
            apoliceComissaoListDTO, false)
    }

    async atualizarCorretorAssessorApoliceComissaoPeriodo(variaveisGlobais, dataInicial, dataFinal) {

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                dataInicialAno: ano(dataInicial),
                dataInicialMes: mes(dataInicial),
                dataInicialDia: dia(dataInicial),
                dataFinalAno: ano(dataFinal),
                dataFinalMes: mes(dataFinal),
                dataFinalDia: dia(dataFinal),
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais,
            HARDCODE.apiApoliceComissaoAtualizarCorretorAssessorApoliceComissaoPeriodo, body, false)
    }
    
    async atualizarNotaFiscalSeguradoraPeriodo(variaveisGlobais, dataInicial, dataFinal, seguradora, cnpjEmpresa,
        processoSeguradora, notaFiscalSeguradora) {

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                dataInicialAno: ano(dataInicial),
                dataInicialMes: mes(dataInicial),
                dataInicialDia: dia(dataInicial),
                dataFinalAno: ano(dataFinal),
                dataFinalMes: mes(dataFinal),
                dataFinalDia: dia(dataFinal),
                seguradora: seguradora,
                cnpjEmpresa: cnpjEmpresa,
                processoSeguradora: processoSeguradora,
                notaFiscalSeguradora: notaFiscalSeguradora,
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais,
            HARDCODE.apiApoliceNotaFiscalSeguradoraPeriodo, body, false)
    }
}

export default ApoliceComissaoService